import React, {useEffect, useRef, useState} from "react";
import {useOutletContext} from "react-router-dom";
import {useFormik} from "formik";
import {InputText} from "primereact/inputtext";
import {Image} from "primereact/image";
import FormGroup from "../components/FormGroup";
import {Calendar} from "primereact/calendar";
import {SelectButton} from "primereact/selectbutton";
import {InputTextarea} from "primereact/inputtextarea";
import {Checkbox} from "primereact/checkbox";
import {Button} from "primereact/button";
import {Avatar} from "primereact/avatar";
import Loader from "../components/Loader";
import {UsersService} from "../services/UsersService";
import {ClientService} from "../services/ClientService";
import {Toast} from "primereact/toast";
import {FileUpload} from "primereact/fileupload";
import {Dialog} from "primereact/dialog";

export default function ClientChildren(props) {

    const context = useOutletContext()
    const toast = useRef()
    const [children, setChildren] = useState(context.children)
    const [loading, setLoading] = useState(false)
    const [avatarDialogVisible, setAvatarDialogVisible] = useState(false)

    const setFormikValues = (formik) => {
        formik.setValues({
            fio: children ? children.fio : '',
            birthday: children ? (children.birthday ? new Date(children.birthday) : '') : '',
            sex: children ? children.sex : '',
            year: children ? (children.year ? new Date(children.year + '-01-01') : '') : '',
            physiological_feature_comment: children ? children.physiological_feature_comment : '',
            if_allergy: children ? !!children.if_allergy : 0,
            if_reaction: children ? !!children.if_reaction : 0,
            if_intolerance: children ? !!children.if_intolerance : 0,
            if_susceptibility: children ? !!children.if_susceptibility : 0,
            if_toilet: children ? !!children.if_toilet : 0,
            if_injuries: children ? !!children.if_injuries : 0,
            psychological_feature_comment: children ? children.psychological_feature_comment : ''
        })
    }

    const formik = useFormik({
        // initialValues: setFormikValues(),
        validate: (data) => {
            let errors = {}

            if (!data.fio) {
                errors.fio = 'Необходимо заполнить имя!'
            }
            if (data.sex < 0 || data.sex === '') {
                errors.sex = 'Необходимо указать пол!'
            }

            return errors
        },
        onSubmit: (data) => {
            console.log(data)
            setLoading(true)
            ClientService.UpdateChild(context.id, data).then((r) => {
                toast.current.show({severity: 'success', summary: 'Данные успешно сохранены!'});
                setLoading(false)
                context.updateUser()
            })
            // console.log(data)

        }
    })


    useEffect(() => {
        console.log(context.children)
        setChildren(context.children)
    }, [context]);
    useEffect(() => {
        setFormikValues(formik)
    }, [children]);


    const isFormFieldInvalid = (name) => !!(formik.touched[name] && formik.errors[name]);

    const getFormErrorMessage = (name) => {
        return isFormFieldInvalid(name) ? <small className="p-error">{formik.errors[name]}</small> :
            <small className="p-error">&nbsp;</small>;
    };


    const uploadAvatarHeaderTemplate = (options) => {
        const {className, chooseButton, uploadButton, cancelButton} = options;
        return (
            <div className={className} style={{backgroundColor: 'transparent', display: 'flex', alignItems: 'center'}}>
                {chooseButton}
            </div>
        )
    }
    const uploadAvatarEmptyTemplate = () => {

        return (
            <div className="d-flex align-items-center flex-column">
                <i className="pi pi-image m-t-3 p-3" style={{
                    fontSize: '2em',
                    borderRadius: '50%',
                    backgroundColor: 'var(--surface-b)',
                    color: 'var(--surface-d)'
                }}></i>
                <span className="my-2">
                    Перетяните изображение в область
                </span>
            </div>
        );

    }

    const uploadAvatarHandler = (e) => {
        setAvatarDialogVisible(false)
        context.updateUser()
    }


    return (
        <>
            <Toast ref={toast}/>
            <div className={'card'}>
                <div className="card-header">
                    <h3 className={'m-b-0'}>Ребенок</h3>
                </div>
                {formik.values &&
                    <div className="card-body">

                        <form className={'base-form'} id={'child-form'} onSubmit={formik.handleSubmit}>

                            <div className="card">
                                <div className="card-body">
                                    <div className="row">

                                        <div className="col-md-6">


                                            <div className={'m-b-30'}>
                                                <Button icon={'pi pi-upload'} type={'button'}
                                                        onClick={(e) => setAvatarDialogVisible(true)}
                                                        label={'Загрузить фото'}></Button>
                                            </div>
                                            <Dialog header="Загрузите фото для ребенка" visible={avatarDialogVisible}
                                                    onHide={() => setAvatarDialogVisible(false)} style={{
                                                width: '50%'
                                            }}>
                                                <div className={'p-t-10'}>
                                                    <FileUpload accept="image/*" name={'file'}
                                                                url={"http://yii2.easytickets.pro/clients/upload-child-avatar?children_id=" + children.id + "&access-token=" + localStorage.getItem('user') + '&type=&multi=0'}
                                                                chooseLabel={'Выбрать изображение'}
                                                                emptyTemplate={uploadAvatarEmptyTemplate}
                                                                onUpload={uploadAvatarHandler}
                                                                headerTemplate={uploadAvatarHeaderTemplate} auto/>
                                                </div>
                                            </Dialog>

                                            {/*<div className="profile-title m-b-10">*/}

                                            {/*            <h3 className="mb-1 f-20 txt-primary">{formik.values.fio}</h3>*/}

                                            {/*            <a href="#" className={'f-12'}>Загрузить*/}
                                            {/*                фото</a>*/}


                                            {/*    */}
                                            {/*</div>*/}

                                            <FormGroup label={'Фамилия и имя ребенка'} error={getFormErrorMessage('fio')}>
                                                <InputText value={formik.values.fio}
                                                           onChange={(e) => formik.setFieldValue('fio', e.target.value)}/>
                                            </FormGroup>



                                            <FormGroup label={'Год рождения'} error={getFormErrorMessage('year')}>
                                                <Calendar view={'year'} dateFormat={'yy'} value={formik.values.year}
                                                          onChange={(e) => formik.setFieldValue('year', e.value)}/>

                                            </FormGroup>



                                            <FormGroup label={'Дата рождения'} error={getFormErrorMessage('birthday')}>
                                                <Calendar dateFormat={'dd/mm/yy'} value={formik.values.birthday}
                                                          onChange={(e) => formik.setFieldValue('birthday', e.target.value)}/>
                                            </FormGroup>


                                            <FormGroup label={'Пол'} error={getFormErrorMessage('sex')}>
                                                <SelectButton optionValue={'value'} value={formik.values.sex}
                                                              onChange={(e) => formik.setFieldValue('sex', e.target.value)}
                                                              options={[{label: 'Мальчик', value: 0}, {
                                                                  label: 'Девочка',
                                                                  value: 1
                                                              }]}/>


                                            </FormGroup>




                                        </div>

                                        <div className="col-md-12 ">


                                            <h4 className={'m-b-20'}>Физиологические особенности</h4>


                                            <div className={'d-flex align-items-center m-b-10'}>
                                                <Checkbox checked={formik.values.if_allergy}
                                                          onChange={(e) => formik.setFieldValue('if_allergy', e.checked)}/>
                                                <label htmlFor="" className={'m-l-10 m-b-0'}>Аллергия</label>
                                            </div>
                                            <div className={'d-flex align-items-center m-b-10'}>
                                                <Checkbox checked={formik.values.if_reaction}
                                                          onChange={(e) => formik.setFieldValue('if_reaction', e.checked)}/>
                                                <label htmlFor="" className={'m-l-10 m-b-0'}>Реакция на продукты питания
                                                    или
                                                    лекарственные препараты</label>
                                            </div>
                                            <div className={'d-flex align-items-center m-b-10'}>
                                                <Checkbox checked={formik.values.if_intolerance}
                                                          onChange={(e) => formik.setFieldValue('if_intolerance', e.checked)}/>
                                                <label htmlFor="" className={'m-l-10 m-b-0'}>Непереносимость каких-либо
                                                    веществ</label>
                                            </div>
                                            <div className={'d-flex align-items-center m-b-10'}>
                                                <Checkbox checked={formik.values.if_susceptibility}
                                                          onChange={(e) => formik.setFieldValue('if_susceptibility', e.checked)}/>
                                                <label htmlFor="" className={'m-l-10 m-b-0'}>Восприимчивость к низкой /
                                                    высокой
                                                    температуре</label>
                                            </div>
                                            <div className={'d-flex align-items-center m-b-10'}>
                                                <Checkbox checked={formik.values.if_toilet}
                                                          onChange={(e) => formik.setFieldValue('if_toilet', e.checked)}/>
                                                <label htmlFor="" className={'m-l-10 m-b-0'}>Особенности посещения
                                                    туалета</label>
                                            </div>
                                            <div className={'d-flex align-items-center m-b-10'}>
                                                <Checkbox checked={formik.values.if_injuries}
                                                          onChange={(e) => formik.setFieldValue('if_injuries', e.checked)}/>
                                                <label htmlFor="" className={'m-l-10 m-b-0'}>Наличие травм / хронических
                                                    заболеваний</label>
                                            </div>

                                            <h4 className={'m-b-20 m-t-30'}>Психологические особенности</h4>


                                            <FormGroup label={'Комментарий'}>
                                                <InputTextarea rows={5} autoResize
                                                               onChange={(e) => formik.setFieldValue('physiological_feature_comment', e.target.value)}
                                                               value={formik.values.physiological_feature_comment}/>
                                            </FormGroup>
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </form>

                    </div>
                }

                <div className="card-footer">
                    <Button type={'submit'} label={'Сохранить'} form={'child-form'}/>
                </div>

                {loading && <Loader/>}
            </div>

        </>
    )
}